export default __webpack_public_path__ + "static/media/1960.2403d3b0.png";